import styled from 'styled-components'

export const MobileColorPickerWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: height 200ms ease-in-out;
  & > *:first-child {
    margin-left: 10px;
  }
  & > div {
    margin-top: -6px;
  }
`
